import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()(() => ({
  select: {
    padding: 5,
  },
}))

export default useStyles
